import { useState, useEffect } from "react";
import {
  Users, Stethoscope, Building2, GraduationCap, Briefcase,
  FileText, ClipboardList, Mail, Sun, CalendarDays, BriefcaseBusiness
} from "lucide-react";
import { getStats } from "../utils/api";

const CARDS = [
  { key: "total_users", label: "Total Users", icon: Users, color: "#1976e0", bg: "#e8f1fd" },
  { key: "total_seekers", label: "Seekers", icon: Stethoscope, color: "#0d9488", bg: "#f0fdfa" },
  { key: "total_recruiters", label: "Recruiters", icon: Building2, color: "#7c3aed", bg: "#f5f3ff" },
  { key: "total_students", label: "Students", icon: GraduationCap, color: "#d97706", bg: "#fffbeb" },
  { key: "active_jobs", label: "Active Jobs", icon: Briefcase, color: "#16a34a", bg: "#f0fdf4" },
  { key: "total_jobs", label: "Total Jobs", icon: BriefcaseBusiness, color: "#475569", bg: "#f8fafc" },
  { key: "total_internships", label: "Internships", icon: ClipboardList, color: "#0ea5e9", bg: "#f0f9ff" },
  { key: "total_applications", label: "Applications", icon: FileText, color: "#dc2626", bg: "#fef2f2" },
  { key: "total_waitlist", label: "Waitlist Signups", icon: Mail, color: "#1976e0", bg: "#e8f1fd" },
  { key: "new_signups_today", label: "New Today", icon: Sun, color: "#d97706", bg: "#fffbeb" },
  { key: "new_signups_week", label: "New This Week", icon: CalendarDays, color: "#16a34a", bg: "#f0fdf4" },
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getStats()
      .then((res) => setStats(res.data))
      .catch((err) => setError(err.response?.data?.error || "Failed to load stats"));
  }, []);

  return (
    <div>
      <h1 className="page-title">Dashboard</h1>
      <p className="page-sub">Platform overview at a glance.</p>

      {error && <div className="error-box" style={{ marginTop: 18 }}>{error}</div>}

      {!stats && !error && (
        <div className="empty">
          <span className="spinner spinner-dark" style={{ width: 26, height: 26 }} />
        </div>
      )}

      {stats && (
        <div className="stat-grid" style={{ marginTop: 20 }}>
          {CARDS.map(({ key, label, icon: Icon, color, bg }) => (
            <div key={key} className="card" style={{
              padding: 18, display: "flex", alignItems: "center", gap: 14
            }}>
              <div style={{
                width: 44, height: 44, borderRadius: 12, background: bg,
                display: "flex", alignItems: "center", justifyContent: "center",
                flexShrink: 0
              }}>
                <Icon size={20} style={{ color }} />
              </div>
              <div style={{ minWidth: 0 }}>
                <p style={{ fontSize: 24, fontWeight: 800, color: "#1a1f2e", lineHeight: 1.1 }}>
                  {stats[key] ?? 0}
                </p>
                <p style={{ fontSize: 12, color: "#718096", fontWeight: 600, marginTop: 3 }}>
                  {label}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
